import { Link } from '@inertiajs/react'
import Navbar from '@/components/layout/Navbar'

interface SeriesItem {
  id: number; title: string; slug: string
  description: string | null; cover_url: string | null; episodes_count: number
}

export default function Index({ series }: { series: SeriesItem[] }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="max-w-5xl mx-auto px-4 py-10">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">All Series</h1>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {series.map(s => (
            <Link key={s.id} href={`/series/${s.slug}`} className="group bg-white rounded-xl border border-gray-100 overflow-hidden hover:shadow-md transition-shadow">
              <div className="aspect-video bg-gradient-to-br from-gray-800 to-gray-900 flex items-center justify-center">
                {s.cover_url ? (
                  <img src={s.cover_url} alt={s.title} className="w-full h-full object-cover" />
                ) : (
                  <span className="text-4xl text-white/20 font-bold">{s.title[0]}</span>
                )}
              </div>
              <div className="p-5">
                <h3 className="font-bold text-gray-900 mb-1 group-hover:text-brand transition-colors">{s.title}</h3>
                <p className="text-sm text-gray-500 line-clamp-2 mb-3">{s.description}</p>
                <p className="text-xs text-gray-400">{s.episodes_count} episodes</p>
              </div>
            </Link>
          ))}
        </div>
        {series.length === 0 && (
          <div className="text-center py-20 text-gray-400">No series yet. Check back soon!</div>
        )}
      </div>
    </div>
  )
}
